import BaseSkeleton from "react-loading-skeleton";
import type { CSSProperties, PropsWithChildren } from "react";
import { css } from "@emotion/react";

export const Skeleton = (
  props: PropsWithChildren<{
    isLoading: boolean;
    className?: string;
    borderRadius?: string | number;
    style?: CSSProperties;
  }>,
) => {
  const {
    isLoading = true,
    borderRadius,
    children,
    style = {},
    className,
  } = props;
  if (!children && isLoading) {
    return (
      <BaseSkeleton
        className={className}
        style={style}
        borderRadius={borderRadius}
      />
    );
  }

  if (isLoading) {
    return (
      <span css={containerStyles} style={style} className={className}>
        <span css={skeletonWrapperStyles}>
          <BaseSkeleton
            borderRadius={borderRadius}
            height={"100%"}
            width={"100%"}
          />
        </span>

        <span css={contentStyles}>{children}</span>
      </span>
    );
  }
  return <>{children}</>;
};

const containerStyles = css({
  position: "relative",
  display: "inline-block",
});

const contentStyles = css({
  opacity: 0,
});

const skeletonWrapperStyles = css({
  position: "absolute",
  inset: 0,
});
